import React from 'react';
import ReactDOM from 'react-dom';
import { initNewRelicBrowser } from './newrelic-browser';
import App from './App';

import './global.css';

// Suppress CRA's error overlay for third-party script errors (crypto wallets,
// ad-blocker noise, NR agent cross-origin failures). Only our own errors
// with a real stack trace should surface.
const origOnerror = window.onerror;
window.onerror = (msg, source, line, col, error) => {
  if (msg === 'Script error.' || (typeof msg === 'string' && msg.includes('ethereum'))) {
    return true;
  }
  if (origOnerror) return origOnerror(msg, source, line, col, error) as any;
  return false;
};

// Initialise the New Relic Browser agent before React mounts so it wraps
// fetch/xhr early and captures first-paint timings.
initNewRelicBrowser();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
